import { makeStyles } from "@fluentui/react-components";

export const useDocumentReaderStyles = makeStyles({
  surface: {
    maxHeight: "90vh",
    "@media screen and (max-width: 600px)": { maxWidth: "90vw", width: "90vw" },
    "@media screen and (min-width: 601px) and (max-width: 10000px)": {
      maxWidth: "430px",
      width: "430px",
    },
    overflowY: "hidden",
    overflowX: "hidden",
    padding: "5px 10px",
  },
});
